<template>
  <div v-if="text" :class="$style.wrapper">
    <div :class="$style.line"></div>
    <UiKitTypography :type="MAP.OVERLINE01D" :class="$style.text">{{
      text
    }}</UiKitTypography>
    <div :class="$style.line"></div>
  </div>
  <div v-else :class="$style.rawDivider"></div>
</template>

<script setup>
import { defineProps } from "vue";
import UiKitTypography from "@/ui-kit/Typography.vue";
import { MAP } from "@/constants/typography";

const props = defineProps(["text"]);
</script>

<style module lang="scss">
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;

  .line {
    flex: 1;
    height: 1px;
    background-color: #050505;
    opacity: 0.16;
  }

  .text {
    color: #6b6b6b;
  }
}

.rawDivider {
  width: 100%;
  height: 1px;
  background-color: var(--HP-grey-07);
}
</style>
